import NoDataIcon from '../../assets/icons/no-data-available.svg';
import { INoDataProps } from '../../interfaces/no-data';
import './index.scss';

export const NoDataAvailable = (props: INoDataProps) => {
    return <div className='data-not-available-container'>
        <div className='not-available-wrapper'>
            <span>{`${props.message != null && props.message !== "" ? props.message : `No Data Available!`}`}</span>
            <img src={NoDataIcon} alt='' />
        </div>
    </div>;
}